import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import i18n from '../../../i18n';
import { Grid } from '@material-ui/core';
import { number } from 'yup';

import { validator } from 'core/form/form';

import { isUIEnabledSelector } from 'state/app/selectors';
import { deliveryServicePlansSelector } from 'state/deliveryService/selector';

import { LargeButton } from 'components/LargeButton/LargeButton';
import { AutocompleteControlField } from 'components/AutocompleteSelect/AutocompleteSelect';

import { Form } from '../types';

export const DeliveryPlanForm = reduxForm({
    form: Form.DELIVERY_PLAN_FORM,
    initialValues: {
        plan: null,
    },
    validate: validator({
        plan: number().nullable().required('common:validation.required'),
    }),
})(props => {
    const { t } = i18n.useTranslation();
    const { handleSubmit } = props;
    const isUIEnabled = useSelector(isUIEnabledSelector);
    const deliveryPlans = useSelector(deliveryServicePlansSelector);
    const deliveryPlansOptions = useMemo(
        () =>
            deliveryPlans.map(p => ({
                label: p.name,
                value: p.id,
            })),
        [deliveryPlans],
    );
    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Field
                        name="plan"
                        component={AutocompleteControlField}
                        label={t('orders:deliveryCard.plan')}
                        isDisabled={deliveryPlansOptions.length === 0}
                        items={deliveryPlansOptions}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LargeButton disabled={!isUIEnabled} type="submit">
                        {t('orders:deliveryCard.nextButton')}
                    </LargeButton>
                </Grid>
            </Grid>
        </form>
    );
});
